import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import styles from './uitk-sheet.css';
var getClassNameList = classNames.bind(styles);
var UitkSheetCloseButton = function (props) {
  var children = props.children;
  var closeButtonContainerClass = getClassNameList('uitk-sheet-close-button-container');
  return React.createElement("div", {
    className: closeButtonContainerClass
  }, children);
};
UitkSheetCloseButton.defaultProps = {
  alignment: 'right'
};
UitkSheetCloseButton.displayName = 'UitkSheetCloseButton';
export { UitkSheetCloseButton };